import "core-js/modules/es.string.starts-with.js";
export var orderNumberToBrandOrderToken = function orderNumberToBrandOrderToken(orderNumber) {
  if (!orderNumber) {
    return "";
  }
  var formattedOrderNumber = orderNumber;
  if (orderNumber.startsWith("#")) {
    formattedOrderNumber = orderNumber.substring(1);
  }
  return "bo_".concat(formattedOrderNumber.toLowerCase());
};